import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export class IndicacaoRevendedorProps {
    public constructor(
        public cnpj: string = '',
        public nomeComercial: string = '',
        public responsavel: string = '',
        public telefone: string = '',
    ) { }
}

export function usePostIndicacaoRevendedor() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIndicacaoRevendedor = useCallback(
        (model: IndicacaoRevendedorProps) =>
            invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/indicacao/revenda`,
                data: model,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIndicacaoRevendedor,
    };
}
